<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="row justify-content-start dashboard-cards-row">

          <div class=" col-lg-12 col-md-12 col-12" v-if="user.role==='3'">
            <div >
              <h2 class="text-white">Bienvenido {{ user.name }}</h2>
            </div>
          </div>
         

          <div class="col-lg-3 col-md-6 col-12 d-flex justify-content-start dashboard-top-card dashboard-card-produccion" v-if="user.role === '1' || user.role === '2'">
          <router-link 
            :to="{ name: 'Production' }" 
            class="card-link"
            
          >
            <card
              :title="stats.projects.title"
              :value="stats.projects.value"
              :percentage="stats.projects.percentage"
              :iconClass="stats.projects.iconClass"
              :iconBackground="stats.projects.iconBackground"
              :titleSectionStyle="true"
              :layoutProduccion="true"
              directionReverse
            ></card>
          </router-link>
        </div>
          <div class="col-lg-3 col-md-6 col-12 d-flex justify-content-start dashboard-top-card" v-if="user.role==='1' || user.role==='2'">
            <router-link 
            :to="{ name: 'Users' }" 
            class="card-link"
            
          >
            <card
              :title="stats.users.title"
              :value="stats.users.value"
              :percentage="stats.users.percentage"
              :iconClass="stats.users.iconClass"
              :iconBackground="stats.users.iconBackground"
              :titleSectionStyle="true"
              :layoutProduccion="true"
              directionReverse
            ></card>
          </router-link>
          </div>

          <div class="col-lg-3 col-md-6 col-12 d-flex justify-content-start dashboard-top-card" v-if="user.role==='1'">
            <router-link 
            :to="{ name: 'Payment' }" 
            class="card-link"
            
          >
            <card
              :title="'Licencia'"
              :value="license.status === 'paid' ? 'Pagado' : 
              license.status === 'pending' ? 'Pendiente' : 
              license.status === 'rejected' ? 'Rechazado' : 
              license.status === 'voided' ? 'Anulado' : 'Validando...'"
              :percentage="new Date(license.coverage_month).toLocaleDateString('es-ES')"
              :iconClass="'fa fa-id-card'"
              :iconBackground="'bg-gradient-dark'"
              :valueColor="getStatusColor(license.status)"
              :percentageColor="getStatusColor(license.status)"
              :titleSectionStyle="true"
              :layoutLicencia="true"
              directionReverse
            ></card>
          </router-link>
          </div>


        </div>
        <div class="row" v-if="user.role==='1' || user.role==='2'">
          <div class="col-lg-12 mb-lg">
            <!-- line chart -->
            <div class="card">
              <gradient-line-chart />
            </div>
          </div>
          <div class="col-lg-5" hidden>
            <carousel />
          </div>
        </div>

        <div class="row" v-if="user.role==='1' || user.role==='2'">
          <div class="col-lg-12 mb-lg">
            <!-- line chart -->
         
                <averias-chart />
            
          </div>
        </div>

         <div class="row" v-if="user.role==='1' || user.role==='2'">
          <div class="col-lg-12 mb-lg">
            <!-- line chart -->
         
                <totales-terminados />
            
          </div>
        </div>

         <div class="row" v-if="user.role==='1' || user.role==='2'">
          <div class="col-lg-12 mb-lg">
            <!-- line chart -->
         
                <informe-extrusion />
            
          </div>
        </div>

         <div class="row" v-if="user.role==='1' || user.role==='2'">
          <div class="col-lg-12 mb-lg">
            <!-- line chart -->
         
                <informe-hornos />
            
          </div>
        </div>


      </div>
    </div>
  </div>
</template>
<script>
import Card from "@/examples/Cards/Card.vue";
import GradientLineChart from "@/examples/Charts/GradientLineChart.vue";
import Carousel from "./components/Carousel.vue";
import AveriasChart from "./components/AveriasChart.vue";
import TotalesTerminados from "./components/TotalesTerminados.vue";
import InformeExtrusion from "./components/InformeExtrusion.vue";
import InformeHornos from "./components/InformeHornos.vue";

export default {
  name: "dashboard-default",
  data() {
    return {
      searchQuery: '', 
      searchQueryUnvalidated: '',
      searchQueryProduction: '',
      stats: {
        projects: {
          title: "Producción activa",
          value: "0",
          percentage: "0%",
          iconClass: "ni ni-folder-17",
          detail: "since yesterday",
          iconBackground: "bg-gradient-info",
        },
        users: {
          title: "Empleados",
          value: "0",
          percentage: "0%",
          iconClass: "ni ni-user-run",
          iconBackground: "bg-gradient-danger",
          detail: "since last week",
        },
        pendingValidation: {
          title: "Sin validar",
          value: "0",
          percentage: "pendientes",
          iconClass: "ni ni-check-bold",
          iconBackground: "bg-gradient-warning",
          detail: "",
        },
      },
      user:{},
      undelivered:[],
      unvalidated:[],
      production:[],
      license:{}
    };
  },
  components: {
    Card,
    GradientLineChart,
    Carousel,
    AveriasChart,
    TotalesTerminados,
    InformeExtrusion,
    InformeHornos
  },
  computed: {
    filteredUndelivered() {
      if (!this.searchQuery) return this.undelivered; 
      
      return this.undelivered.filter(value => {
        const productionId = value.production.id.toString().toLowerCase();
        const userName = value.user.name.toLowerCase();
        const query = this.searchQuery.toLowerCase();
        return productionId.includes(query) || userName.includes(query);
      });
    },
    filteredUnvalidated() {
      if (!this.searchQueryUnvalidated) return this.unvalidated;

      return this.unvalidated.filter(value => {
        const productionId = value.production.id.toString().toLowerCase();
        const userName = value.user.name.toLowerCase();
        const query = this.searchQueryUnvalidated.toLowerCase();
        return productionId.includes(query) || userName.includes(query);
      });
    },
    filteredProduction() {
      if (!this.searchQueryProduction) return this.production;

      return this.production.filter(value => {
        const productionId = value.id.toString().toLowerCase();
        const productionName = value.name.toLowerCase();
        const query = this.searchQueryProduction.toLowerCase();
        return productionId.includes(query) || productionName.includes(query);
      });
    }
  },
  methods: {
    redirectToProduction(value) {
      this.$router.push({ 
        name: 'Production Create', 
        params: { data: JSON.stringify(value) } 
      });
    },
    isValidDate(date) {
      if (!date) {
        return false;
      }
      const parsedDate = new Date(date);
      return !isNaN(parsedDate.getTime());
    },
      async fetchAnalytics() {
        try {
          const response = await this.$store.dispatch('analitycs/getCards');
          const payload = response?.data?.data ?? response?.data ?? this.$store.state.analitycs.cards ?? {};
          const users = payload?.users || {};
          const projects = payload?.projects || {};

          this.stats.users = {
            ...this.stats.users,
            ...users,
            value: users.value ?? this.stats.users.value,
            percentage: users.percentage ?? this.stats.users.percentage,
          };
          this.stats.projects = {
            ...this.stats.projects,
            ...projects,
            value: projects.value ?? this.stats.projects.value,
            percentage: projects.percentage ?? this.stats.projects.percentage,
          };
        } catch (error) {
          console.error("Error cargando cards del dashboard:", error);
        }
      },
      async fetchUndelivered() {
        let datos = await this.$store.dispatch('analitycs/getUndelivered'); 
        this.undelivered = datos.data;
      },
      async fetchUnvalidated() {
        try {
          const datos = await this.$store.dispatch('analitycs/getUnvalidate');
          this.unvalidated = datos?.data || [];
          if (!this.stats.pendingValidation) {
            this.stats.pendingValidation = {
              title: "Sin validar",
              value: "0",
              percentage: "pendientes",
              iconClass: "ni ni-check-bold",
              iconBackground: "bg-gradient-warning",
              detail: "",
            };
          }
          this.stats.pendingValidation.value = String(this.unvalidated.length || 0);
        } catch (error) {
          console.error("Error cargando pendientes por validar:", error);
          this.unvalidated = [];
          if (this.stats.pendingValidation) this.stats.pendingValidation.value = "0";
        }
      },
      async fetchProduction() {
        let datos = await this.$store.dispatch('analitycs/getProduction'); 
        this.production = datos.data;
      },
      async fetchLicense() {
        this.license = await this.$store.dispatch('payments/get'); 
        console.log( this.license );
      },
      getStatusColor(status) {
        switch (status) {
          case 'paid':
            return 'text-success';  // Color verde para "Pagado"
          case 'pending':
            return 'text-warning';  // Color amarillo para "Pendiente"
          case 'rejected':
            return 'text-danger';   // Color rojo para "Rechazado"
          case 'voided':
            return 'text-muted';    // Color gris para "Anulado"
          default:
            return 'text-secondary'; // Color por defecto
        }
      }
  },
  mounted() {

    let user = JSON.parse(localStorage.getItem('user'));
    this.user = user;

    if(user.role==='1' || user.role==='2'){
      this.fetchAnalytics(); 
      this.fetchUndelivered(); 
      this.fetchUnvalidated(); 
      this.fetchProduction(); 
      this.fetchLicense();
    }

    
  },
};
</script>

<style scoped>
.dashboard-cards-row .card-link {
  width: 100%;
  max-width: 260px;
  display: block;
}
/* En responsive las tarjetas ocupan el ancho completo */
@media (max-width: 991.98px) {
  .dashboard-cards-row .card-link {
    max-width: none;
  }
}
.dashboard-top-card :deep(.card) {
  width: 100%;
  min-height: 130px;
}
.dashboard-card-produccion :deep(.card-title-label) {
  white-space: nowrap;
}
</style>
